/** canonical や OGP に使うサイトの URL */
export const SITE_ORIGIN: string = import.meta.env.VITE_SITE_ORIGIN ?? 'https://focus-cafe.space'
